import store from './store';
import _, { identity } from 'lodash';

const currentYear = new Date(Date.now()).getFullYear() + 1;
const startYear = currentYear - 20;

const yearRange = [];

for (let i = startYear; i < currentYear; i++) {
  yearRange.push(i);
}

let constants = {
  lirsHeader: {
    logoPath: "/img/lirs.jpg",
    title: "LAGOS STATE INTERNAL REVENUE SERVICE",
    address: "Lagos Revenue House, Assbifi Rd, Central Business District, Alausa, Lagos"
  },
  maxAllowedExportedData: 1000,
  minSessionWindowLimit: 10, // Currently 10 minutes (It can be set to 5 or any for taxpayer if logic to change)
  maxSessionWindowLimit: 10, // 10 minutes (For Admins)
  touchSessionInterval: 4, // 4 minutes
  remitaUrl: "https://lagos.techpay.ng",
  login: {
    payer: "Payer Login",
    consultant: "Consultant Login",
    admin: "Admin Login"
  },
  globalStatus: [
    {id: '1', name: 'Active'},
    {id: '2', name: 'In Active'}
  ],
  taxPayerTypes: [
    {name: "Individual", value: "1"},
    {name: "Corporate", value: "2"}
  ],
  identificationTypeCollection: [
    {name: 'BVN', value: 1},
    {name: 'Passport', value: 3},
    {name: 'NIN', value: 4},
    {name: 'VIN', value: 5},
    {name: 'BID', value: 6}
  ],
  identificationTypesCorporate: [
    {name: 'CAC', value: 2}
  ],
  cacTypes: ["RC", "BN", "IT"],
  individualEntityTypeId: "1",
  corporateEntityTypeId: "2",
  bvnTypeId: 1,
  cacTypeId: 2,
  passportTypeId: 3,
  returnTypesToDownloadErrorDocsOnReturns: ['annual', 'projection', 'wht'],
  ninTypeId: 4,
  specialEntityTypeId: 7,
  identificationTypes: {
    1: 'BVN',
    2: 'CAC',
    3: 'Passport',
    4: 'NIN',
    5: 'VIN',
    6: 'BID',
    7: 'Special Entity'
  },
  nigeriaNationalityId: 1,
  active: 1,
  inActive: 2,
  removed: 3,
  flagged: 38,
  closed: 10,
  draft: 14,
  under_review: 53,
  upheld_statutory_timeout: 52,
  approved: 33,
  completed: 7,
  cancelled: 6,
  pending: 32,
  rejected: 48,
  canceled: 42,
  adminUserType: {id: 1, isLeader: 1},
  consultantUserType: {id: 2, isLeader: 0},
  dpBounce: 100,
  naira: '&#8358;',
  titles: {
    1: 'Mr. ',
    2: 'Miss. ',
    3: 'Mrs. ',
    4: 'Chief. ',
    5: 'Dr. ',
    6: 'Engr. ',
  },
  titlesByMale: ['Mr', 'Mr.'],
  titlesByFeMale: ['Mrs', 'Mrs.', 'Miss'],
  years: [...yearRange],
  baseYear: 2019,
  months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
  returnTypes: [
    {
      name: 'Monthly Returns',
      value: 1
    },
    {
      name: 'Payroll Summary',
      value: 2
    },
    {
      name: 'New Year Projections',
      value: 3
    },
    {
      name: 'Withholding Tax',
      value: 4
    },
  ],
  allowances: {
    'housing': 1,
    'transport': 2,
    'meal': 3,
    'utility': 4,
    'entertainment': 5,
    'benefit in kind': 6,
    'leave allowance': 7,
    'bonus': 8,
    'others': 9
  },

  codeAgencyLIRS: '13004',
  codeRevenuePaye: '32101',
  fileUploadMaxSize: 5, // 5MB
  payeTemplatedefaultHeaders: [
    'name',
    'tax_payer_number',
    'nationality',
    'designation',
    'no_of_months'
  ],

  auditStates: [
    { id: 1, label: 'Allocation Collected' },
    { id: 2, label: 'Fieldstaff Notified' },
    { id: 3, label: 'Active' },
    { id: 4, label: 'New' },
    { id: 5, label: 'Allocation Printed' },
    { id: 6, label: 'BOJ Printed' },
    { id: 7, label: 'Dem Notice Printed' },
    { id: 8, label: 'Report Submitted' },
    { id: 9, label: 'Authenticated' },
    { id: 10, label: 'Revoked' },
    { id: 11, label: 'Non Compliance Printed' },
    { id: 12, label: 'Audit Extended' },
    { id: 13, label: 'Report Rejected' },
    { id: 14, label: 'Extension Letter Printed' },
    { id: 15, label: 'Revised Liability Printed' },
    { id: 16, label: 'Deleted' },
    { id: 17, label: 'System Revoked' },
    { id: 18, label: 'BOJ Requested' },
    { id: 19, label: 'Hidden' },
    { id: 20, label: 'Testing Data' },
    { id: 21, label: 'Allocation Returned' },
    { id: 22, label: 'BOJ Submitted' },
    { id: 23, label: 'Company Duplicated' }
  ],

  taxLaws: {
    revision_2026: 2026
  },

  loginUrls: [
    '/corporate-admin/login',
    '/consultant/login',
    '/admin/login',
    '/login'
  ],

  identityLabels: {
    ebs: 'Payer ID',
    tin: 'TIN',
    jrb: 'Tax ID',
  },

  hospitalitySectorId: 10, // This is to enable HORC tab for Corporate payer for HORC type returns

  userCan: (permissions) => { //permissions should be an array
    const userAuthData = store.state.auth && store.state.auth.userData && store.state.auth.userData.auth_data;
    if(!userAuthData) return false;

    const userPermissions = Object.keys(userAuthData.permissions);
    return _.difference(permissions, userPermissions).length < permissions.length;  //The user should have at least one of the permissions
  },

  hasNestedAccess(allowed_perms) {
    const { permissions } = store.state.auth && store.state.auth.userData && store.state.auth.userData.auth_data;
    if(!permissions) return false;

    if (permissions && permissions[allowed_perms[0]]) {
      const { extra_permissions } = permissions[allowed_perms[0]];
      return extra_permissions.includes(allowed_perms[1]);
    }

    return false;
  },

  noResults(entityName) {
    return `There are currently no ${entityName}`;
  },
  FLAGGED_OBJECTION_AGE_THRESHOLD_IN_DAYS: 60,
  ADMIN_UPDATE_PASSWORD_RESEND_IN_SECS: 30,
  taxpayerUserTypeId: 3,
  doughnutChartBgColors: ["#4caf50", "#FF9D00"]
};

export default constants;
